import { render } from "./group-input.vue?vue&type=template&id=0a3079ed"
import script from "./group-input.vue?vue&type=script&lang=js"
export * from "./group-input.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__